import { useContext } from "react";
import { PeopleContext } from "./PeopleContext";

export const usePeopleContext = () => {
  const context = useContext(PeopleContext);

  if (!context) {
    throw new Error(
      "usePeopleContext must be used within a PeopleContextProvider",
    );
  }

  return context;
};
